// Typed client for the geocode-company edge function.
// Returns the standard `{ success, data }` envelope, so this extends
// BaseEdgeFnClient and uses callOrThrow (unlike CompanyLookupEdgeFnClient,
// which proxies non-standard GUS/BDO envelopes).

import { BaseEdgeFnClient } from './BaseEdgeFnClient.ts';

// ── Response types ──────────────────────────────────────────────────────

export interface GeocodeCompanyResult {
  status: string;
}

export interface BackfillPendingResult {
  processed: number;
  ok: number;
  partial: number;
  not_found: number;
  errors: number;
  /** Rows the cooldown suppressed — selected as pending but not re-sent to Google. */
  skipped: number;
  remaining: number;
}

// ── Client ──────────────────────────────────────────────────────────────

export class CompanyGeocodingEdgeFnClient extends BaseEdgeFnClient {
  /** Geocode a single company's address. Failure never breaks the caller's save flow. */
  async geocodeCompany(companyId: number): Promise<GeocodeCompanyResult> {
    return this.callOrThrow<GeocodeCompanyResult>('geocode-company', {
      action: 'geocode_one',
      company_id: companyId,
    });
  }

  /** Batch-process companies still pending geocoding (optionally including previously failed ones). */
  async backfillPending(limit?: number, includeFailed?: boolean): Promise<BackfillPendingResult> {
    return this.callOrThrow<BackfillPendingResult>('geocode-company', {
      action: 'backfill_pending',
      limit,
      include_failed: includeFailed,
    });
  }
}
